import { AlertCircle } from 'lucide-react';

export function BrandingErrorPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md text-center">
        <div className="flex justify-center mb-4">
          <AlertCircle className="h-12 w-12 text-destructive" />
        </div>
        <h1 className="text-xl font-semibold text-foreground mb-2">
          Site Not Available
        </h1>
        <p className="text-muted-foreground mb-4">
          This site is currently not accessible. If you believe this is an error, please contact the site administrator.
        </p>
        <div className="text-sm text-muted-foreground">
          Error Code: 1001
        </div>
      </div>
    </div>
  );
} 